import {AiFillHome} from 'react-icons/ai'
import {BsPersonFill} from 'react-icons/bs'
import {MdHomeRepairService} from 'react-icons/md'
import {AiFillMessage} from 'react-icons/ai'
import {BsFileEarmarkImageFill} from 'react-icons/bs'
import React from 'react'


const data = [
    {id: 1, link: '#', icon: <AiFillHome/>},
    {id: 2, link: '#about', icon: <BsPersonFill/>},
    {id: 3, link: '#projects', icon:<BsFileEarmarkImageFill/>},
    {id: 4, link: '#services', icon: <MdHomeRepairService/>},
    {id: 5, link: '#contact', icon: <AiFillMessage/>}
]


export default data